import { setBosInfo, setUserInfo } from '@/states/store'
import request from '@/utils/request'
import { getCookie } from '@/utils/cookie'
// import * as Sentry from '@sentry/react'

export const getUserInfo = async () => {
  if (getCookie('token')) {
    const res = await getUserApi()
    const { data }: any = res || {}
    // setUserInfo({ ...data });
    setUserInfo({ ...data})
    // Sentry.setUser({
    //   id: data.userId,
    //   username: data.nickname,
    //   memberStatus: data.memberStatus,
    //   mobile: data.mobileNo,
    // })
    return data;
  }
}

export const getBosInfo = async () => {
  if (getCookie('token')&&getCookie('saasBosId')) {
    const res:any = await getBosApi({bosId:getCookie('saasBosId')})
    const { data } = res || {}
    setBosInfo({...data})
    console.log('getBosInfo',data)
    return data;
  }
}
const getBosApi = (data:any) => {
  return request({
    data,
    url: '/waic/core/common/getBosInfo',
  })
}

const getUserApi = () => {
  return request({
    url: '/waic/account/user/info/get',
  })
}
